import React from 'react';

import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';


interface Props {
  title: string;
  isExporting: boolean;
  buttonProps: any;
  tooltipProps: any;
  onClickAction(event: React.MouseEvent<HTMLElement>): void;
}
const ExportButtonComponent = (props: Props) => {
  const { tooltipProps, buttonProps, title, isExporting, onClickAction } = props;

  return (
    <>
      <TooltipHost
        content={tooltipProps.content}
        directionalHint={DirectionalHint.leftTopEdge}
      >
        <DefaultButton
          iconProps={{
            iconName: 'Download',
            styles: {
              root: {
                fontSize: 24,
                height: 24,
                width: 24,
                lineHeight: 24,
                backgroundColor: '#eaeaea',
                boxSizing: 'content-box',
                marginLeft: 0,
                padding: 8,
                borderRadius: 8
              }
            }
          }}
          text={title}
          ariaLabel={buttonProps.ariaLabel}
          disabled={buttonProps.disabled}
          onClick={onClickAction}
          styles={{
            root: {
              backgroundColor: 'transparent',
              height: 40,
              paddingLeft: 0
            },
            rootHovered: {
              backgroundColor: 'transparent'
            }
          }}
        />
      </TooltipHost>
      {isExporting && (
        <Spinner size={SpinnerSize.small} />
      )}
    </>
  );
}

export default ExportButtonComponent;